import React, { useState, useEffect, useContext } from 'react';
import InputLogin from '../../inputs/InputLogin'
import Switch from '../../switch/Switch'
import TextArea from '../../textArea/TextArea'
import UploadPDF from '../../inputs/UploadPDF'

import ButtonBack from '../../../components/button/ButtonBack'
import ButtonNext from '../../../components/button/ButtonWhite'
import ButtonCheckBoxTransparent from '../../../components/button/ButtonCheckBoxTransparent'


import { ReactComponent as BACK } from '../../../assets/IconsColurs/IconsGeneral/chevronLeft.svg';
import { ReactComponent as NEXT } from '../../../assets/IconsColurs/IconsGeneral/chevronRight.svg';


import { UtilContext } from "../../../context/UtilContext";
import { GLOBAL_LANGUAGE } from "../../../language/language";

const Step5 = ({
  onClick,
  errorMesagge = "",
  documentsStep5,
  setdocumentsStep5,
  setTermAndConditionDate,
  TermAndConditionDate,
  setextraFundDetail,
  setoriginFund,
  originFund,
  haveExtraFund,
  sethaveExtraFund,
  extraFundDetail,
  originFundError,
  haveExtraFundError,
  extraFundDetailError,
  TermAndConditionDateError,
  documentsStep5Error,
  onClickBack,
  loading,
  DataOnboarding,
  LoadingLayouts,
  LoadingBack

}) => {

  const [isReady, setIsReady] = useState(false);

  const { language } = useContext(UtilContext); // Usa el contexto de Auth
  const t = GLOBAL_LANGUAGE[language] || GLOBAL_LANGUAGE.es;

  const [terminosCondiciones, setTerminosCondiciones] = useState(false)
  const [ingresos, setIngresos] = useState(false)
  const [textFondos, setTextFondos] = useState('')

  useEffect(() => {
    if (
      !LoadingLayouts

    ) {
      setIsReady(true)
    }
  }, [
    LoadingLayouts
  ]);
  if (!isReady) {
    return <div className="flex md:flex-row flex-wrap p-4 w-full" >
      <div className="w-full" >
        <div style={{ height: "50vh", }} className='flex items-center justify-center'>
          <div className="h-20  w-20 flex">
            <div className="spinner-border-white-full animate-spin w-14 h-14 border-4 border-white border-t-transparent rounded-full"></div>

          </div>
        </div>
      </div>
    </div>

  }


  return (
    <div className="w-full h-fit pb-16"  >
      <div className='gap-2 flex flex-col ' >
        <p className=" text-2xl mt-8 " style={{ fontFamily: "brico" }} >
          {t.steps5.title}

        </p>
        <p className="text-[#B7B7B9]  flex   text-[14px]">
          {t.steps5.description}
        </p>
        <TextArea onChange={setoriginFund} value={originFund} error={originFundError} subtitleLeft={t.steps2.min_caracters} subtitleRight={'Ver declaración de origen de fondos'} placeholder={t.steps5.placeholder_description} />
      </div>
      {language !== "en" && <div className='flex flex-col gap-1 py-4 '>
        <p className='text-[#B7B7B9]' >{t.documents.statement_origin_fund}</p>
        <UploadPDF setUploadedFile={setdocumentsStep5} uploadedFile={documentsStep5} error={documentsStep5Error} />
      </div>}
      <div className='w-full bg-[#5E5E63] h-[1px] '></div>
      {language === 'es' && <div className='w-full flex gap-11 py-3' >
        <p className='text-[#B7B7B9]' >{t.steps5.other_income}</p>
        <Switch setValue={sethaveExtraFund} value={haveExtraFund} />
      </div>}
      {haveExtraFund && <div>
        <p className='text-[#B7B7B9] py-1' >{t.steps5.other_income_description}</p>
        <TextArea value={extraFundDetail} onChange={setextraFundDetail} error={extraFundDetailError} subtitleLeft={t.steps2.min_caracters} placeholder={t.steps5.placeholder_other_income_description} />
      </div>}
      <div className={`w-full  h-[1px] bg-[#5E5E63] `}></div>
      {/*  <div className={`w-full  h-[1px] ${TermAndConditionDateError ? 'bg-[#FF928B]' : 'bg-[#5E5E63]'} `}></div> */}
      <div className='w-full flex justify-between items-center py-3'>
        <div className='flex flex-row items-center gap-2'>
          <ButtonCheckBoxTransparent setValue={DataOnboarding != null ? () => { } : setTermAndConditionDate} value={DataOnboarding != null ? "true" : TermAndConditionDate} label={t.steps5.label_checkbox} error={TermAndConditionDateError} />
        </div>

        <button
          className='text-[#5E5E63] underline'
          onClick={() => setTerminosCondiciones(!terminosCondiciones)}
        >
          {terminosCondiciones ? t.steps5.label_see_less : t.steps5.label_see_more}
        </button>

      </div>
      {terminosCondiciones && <p className=' text-justify text-[#8A8A8E] text-xs pb-3 ' >
        {t.steps5.terms_and_conditions}
        <a href="https://www.colurs.io/" target='_blanck' className='text-white' > https://www.colurs.io/</a>
      </p>}
      {/*  <div className={`w-full  h-[1px] ${TermAndConditionDateError ? 'bg-[#FF928B]' : 'bg-[#5E5E63]'} `}></div> */}
      <div className={`w-full  h-[1px] bg-[#5E5E63] `}></div>
      {errorMesagge && (
        <div className="w-full flex flex-col mt-4 mb-4">
          <p className="text-[#FF928B] text-[16px]">{errorMesagge}</p>
        </div>
      )}
      <div className='flex flex-col-reverse md:flex-row justify-between w-full gap-4 mt-8' >
        <ButtonBack
          label={t.steps5.label_button_back}
          Icon={BACK}
          onClick={onClickBack}
          loading={LoadingBack}
          className="w-full md:w-auto"
        />
        <ButtonNext
          label={t.steps5.label_button_next}
          Icon={NEXT}
          onClick={onClick}
          loading={loading}
          className="w-full md:w-auto"
        />
      </div>
    </div >

  );
};

export default Step5;

